import * as types from './ItemsSelectActionTypes';

export function selectAllItems(selectedItems) {
  return {
    type: types.SELECT_ALL_ITEMS,
    selectedItems,
  };
}

export function selectItems(selectedItems) {
  return {
    type: types.SELECT_ITEMS,
    selectedItems,
  };
}

export function unselectAllItems() {
  return {
    type: types.UNSELECT_ALL_ITEMS,
  };
}

export function unselectItems(selectedItems) {
  return {
    type: types.UNSELECT_ITEMS,
    selectedItems,
  };
}

export function unselectItem(selectedItem) {
  return {
    type: types.UNSELECT_ITEM,
    selectedItem,
  };
}
